import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
}

const fieldStyles =
  'w-full min-h-[44px] px-4 bg-raised border border-line-strong rounded-sm text-sm text-ink placeholder:text-ink-faint focus:outline-none focus:border-accent transition-colors';

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, className = '', ...rest }, ref) => (
    <label className="block">
      {label && <span className="label-caps text-ink-muted block mb-2">{label}</span>}
      <input ref={ref} className={`${fieldStyles} ${className}`} {...rest} />
    </label>
  )
);
Input.displayName = 'Input';

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, className = '', children, ...rest }, ref) => (
    <label className="block">
      {label && <span className="label-caps text-ink-muted block mb-2">{label}</span>}
      <select ref={ref} className={`${fieldStyles} ${className}`} {...rest}>
        {children}
      </select>
    </label>
  )
);
Select.displayName = 'Select';

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, className = '', ...rest }, ref) => (
    <label className="block">
      {label && <span className="label-caps text-ink-muted block mb-2">{label}</span>}
      <textarea ref={ref} className={`${fieldStyles} py-3 min-h-[88px] ${className}`} {...rest} />
    </label>
  )
);
Textarea.displayName = 'Textarea';
